export default __webpack_public_path__ + "static/media/fav_icon.c6c74894.jpeg";